<script lang="ts">
import { ContextMenu as ContextMenuPrimitive } from "bits-ui";
import { cn, type WithoutChildrenOrChild } from "$lib/utils.ts";
import ContextMenuPortal from "./context-menu-portal.svelte";
import type { ComponentProps } from "svelte";

let {
  ref = $bindable(null),
  portalProps,
  class: className,
  ...restProps
}: ContextMenuPrimitive.ContentProps & {
  portalProps?: WithoutChildrenOrChild<
    ComponentProps<
      typeof ContextMenuPortal
    >
  >;
} = $props();
</script>

<ContextMenuPortal {...portalProps}>
  <ContextMenuPrimitive.Content
    bind:ref
    data-slot="context-menu-content"
    class={cn(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-end-2 data-[side=right]:slide-in-from-start-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--bits-context-menu-content-available-height) min-w-[8rem] origin-(--bits-context-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
      className,
    )}
    {...restProps}
  />
</ContextMenuPortal>
